/*
 * -----------------------------------------------------------------------
 *  <copyright file="audit-log/types/study-crf.tsx" company="Triumph Research Intelligence">
 *      Copyright (C) 2019 by Triumph Research Intelligence. All rights reserved.
 *  </copyright>
 * -----------------------------------------------------------------------
 */

import React from 'react';
import { FieldChangeGrid } from 'views/pages/admin/audit-log/change-grid';
import { getProcessedFieldChangeItems, getFieldChangeItems } from 'views/pages/admin/audit-log/service';
import { convertRules } from '@utils/convertor';
import { studyCrfHistory_OpraQueries_studyCrfHistory_StudyCrf } from '@queries/generated/audit.generated';

interface IStudyCrfRecordChangeGrid {
    oldRecord: studyCrfHistory_OpraQueries_studyCrfHistory_StudyCrf & { CfId: { $oid: string } };
    newRecord: studyCrfHistory_OpraQueries_studyCrfHistory_StudyCrf & { CfId: { $oid: string } };
    oldItem: studyCrfHistory_OpraQueries_studyCrfHistory_StudyCrf;
    newItem: studyCrfHistory_OpraQueries_studyCrfHistory_StudyCrf;
}

const StudyCrfRecordChangeGrid = ({ oldRecord, newRecord, oldItem, newItem }: IStudyCrfRecordChangeGrid) => {
    const refactoredOldRecord = {
        ...oldRecord,
        CrfRules: convertRules(oldItem?.crfRules),
        CfId: oldRecord?.CfId?.$oid,
    };

    const refactoredNewRecord = {
        ...newRecord,
        CrfRules: convertRules(newItem?.crfRules),
        CfId: newRecord?.CfId?.$oid,
    };

    const items = getFieldChangeItems(refactoredOldRecord, refactoredNewRecord, null, (field: string) =>
        getProcessedFieldChangeItems({
            oldRecord: refactoredOldRecord,
            newRecord: refactoredNewRecord,
            oldItem,
            newItem,
            field,
        }),
    );

    return <FieldChangeGrid items={items} />;
};

export { StudyCrfRecordChangeGrid };
